"use strict";

exports.__esModule = true;
exports.truncateAddress = truncateAddress;
function truncateAddress(address) {
  return address.replace(/^(.{0,4}).+?(.{0,4})$/, '$1...$2');
}